import { computed, inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { InfoPagesService as InfoPagesApiService, InfoPageGroupWithPagesResponseDto } from '@/api';

interface InfoPagesState {
  groups: InfoPageGroupWithPagesResponseDto[];
  loading: boolean;
  error: string | null;
}

const initialState: InfoPagesState = {
  groups: [],
  loading: false,
  error: null,
};

@Injectable({ providedIn: 'root' })
export class InfoPagesService {
  private readonly infoApi = inject(InfoPagesApiService);

  private readonly state = signal<InfoPagesState>(initialState);

  readonly groups = computed(() => this.state().groups);
  readonly loading = computed(() => this.state().loading);
  readonly error = computed(() => this.state().error);

  async loadGroups(): Promise<void> {
    if (this.state().groups.length > 0) {
      return;
    }

    this.state.update((s) => ({ ...s, loading: true, error: null }));

    try {
      const groups = await firstValueFrom(this.infoApi.getPublishedInfoPagesGrouped());
      this.state.update((s) => ({ ...s, groups: groups ?? [] }));
    } catch {
      this.state.update((s) => ({
        ...s,
        error: 'Не удалось загрузить информационные страницы',
      }));
    } finally {
      this.state.update((s) => ({ ...s, loading: false }));
    }
  }
}
